// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Promotion-module__wrapper___HJKSr {
  display: flex;
  width: 1238px;
  padding: 0px 60px;
  justify-content: space-between;
  align-items: center;
  border-radius: 42px;
  background: var(--color-primary);
}

.Promotion-module__content____7gJB {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;
}

.Promotion-module__image___hslzh {
  width: 277px;
  height: 302px;
}

.Promotion-module__title___Zsteu {
  font: var(--font-h4);
  color: var(--color-surface);
  text-align: center;
  width: 642px;
}

.Promotion-module__wrap___g0sJ2 {
  display: flex;
  width: 622px;
  justify-content: center;
  align-items: flex-start;
  gap: 14px;
  flex-wrap: wrap;
}

.Promotion-module__store___i5Vpq {
  width: 118px;
  height: 30px;
}

@media (min-width: 768px) and (max-width: 1199px) {

  .Promotion-module__wrapper___HJKSr {
    width: 692px;
    height: 321px;
    padding: 0px 30px;
  }

  .Promotion-module__content____7gJB {
    gap: 20px;
  }

  .Promotion-module__image___hslzh {
    display: flex;
    width: 204px;
    height: 264px;
    flex-direction: column;
    justify-content: flex-end;
  }

  .Promotion-module__title___Zsteu {
    width: 428px;
  }

  .Promotion-module__wrap___g0sJ2 {
    justify-content: center;
    width: 428px;
  }

}

@media (min-width: 360px) and (max-width: 767px) {

  .Promotion-module__wrapper___HJKSr {
    width: 324px;
    padding: 30px 18px 0px 18px;
    flex-direction: column;
  }

  .Promotion-module__content____7gJB {
    align-items: center;
    gap: 20px;
  }

  .Promotion-module__image___hslzh {
    display: flex;
    width: 204px;
    height: 248px;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
  }

  .Promotion-module__image___hslzh img {
    width: 100%;
  }

  .Promotion-module__title___Zsteu {
    width: 302px;
  }

  .Promotion-module__wrap___g0sJ2 {
    width: 288px;
    gap: 8px;
    justify-content: center;
  }

  .Promotion-module__store___i5Vpq {
    width: 93px;
    height: 23px;
  }

}`, "",{"version":3,"sources":["webpack://./src/widgets/promotion/ui/Promotion.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;AAEF;;AAEA;;EAEE;IACE,YAAY;IACZ,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;AAEF","sourcesContent":[".wrapper {\n  display: flex;\n  width: 1238px;\n  padding: 0px 60px;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 42px;\n  background: var(--color-primary);\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 30px;\n}\n\n.image {\n  width: 277px;\n  height: 302px;\n}\n\n.title {\n  font: var(--font-h4);\n  color: var(--color-surface);\n  text-align: center;\n  width: 642px;\n}\n\n.wrap {\n  display: flex;\n  width: 622px;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.store {\n  width: 118px;\n  height: 30px;\n}\n\n@media (min-width: 768px) and (max-width: 1199px) {\n\n  .wrapper {\n    width: 692px;\n    height: 321px;\n    padding: 0px 30px;\n  }\n\n  .content {\n    gap: 20px;\n  }\n\n  .image {\n    display: flex;\n    width: 204px;\n    height: 264px;\n    flex-direction: column;\n    justify-content: flex-end;\n  }\n\n  .title {\n    width: 428px;\n  }\n\n  .wrap {\n    justify-content: center;\n    width: 428px;\n  }\n\n}\n\n@media (min-width: 360px) and (max-width: 767px) {\n\n  .wrapper {\n    width: 324px;\n    padding: 30px 18px 0px 18px;\n    flex-direction: column;\n  }\n\n  .content {\n    align-items: center;\n    gap: 20px;\n  }\n\n  .image {\n    display: flex;\n    width: 204px;\n    height: 248px;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: center;\n  }\n\n  .image img {\n    width: 100%;\n  }\n\n  .title {\n    width: 302px;\n  }\n\n  .wrap {\n    width: 288px;\n    gap: 8px;\n    justify-content: center;\n  }\n\n  .store {\n    width: 93px;\n    height: 23px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Promotion-module__wrapper___HJKSr`,
	"content": `Promotion-module__content____7gJB`,
	"image": `Promotion-module__image___hslzh`,
	"title": `Promotion-module__title___Zsteu`,
	"wrap": `Promotion-module__wrap___g0sJ2`,
	"store": `Promotion-module__store___i5Vpq`
};
export default ___CSS_LOADER_EXPORT___;
